namespace GeniuzPOS.Inventory {
    export class IcStockReturnOutDtColumns {
        static columnsKey = 'Inventory.IcStockReturnOutDt';
    }
}
